import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "./Reveal.jsx";

export default function ProductReach() {
  return (
    <section data-analytics-section="product-reach" className="kw-section kw-product-reach"
      aria-labelledby="product-reach-title"
    >
      <Reveal>
        <span className="kw-small-label">PRODUCTS WITH A GLOBAL FOOTPRINT</span>
        <h2 id="product-reach-title">
          Built here.
          <br />
          Used around the world.
        </h2>
        <p>
          Our applications have reached users across more than{" "}
          <strong>70 countries.</strong>
        </p>
        <Link
          to="/apps"
          className="kw-text-link"
          data-analytics="reach_portfolio"
        >
          Explore our product portfolio <ArrowUpRight size={17} />
        </Link>
      </Reveal>
      <Reveal className="kw-product-reach-map" delay={100}>
        <figure>
          <img
            src="/images/portfolio/product-usage-map.png"
            alt="Original world map highlighting countries where Karalewich products have been used"
            width="1800"
            height="926"
            loading="lazy"
          />
          <figcaption>
            Product-usage footprint from our published portfolio.
          </figcaption>
        </figure>
      </Reveal>
    </section>
  );
}
